export default class MenuItem {
    constructor(el, parent = null, updateOpenItems, isModal) {
        this.DOM = { el: el };
        this.DOM.backdrop = document.querySelector('[data-menu-backdrop]');
        this.updateOpenItems = updateOpenItems;
        this.menuItem = this.DOM.el.dataset.menuItem;
        this.primary = parent === null;
        this.isModal = isModal;
        this.siblings = [];
        this.children = [];
        this.DOM.children = document.querySelectorAll(`[data-menu-parent="${this.menuItem}"]`);
        this.DOM.toggles = document.querySelectorAll(`[data-menu-toggle="${this.menuItem}"]`);
        this.isOpen = this.DOM.el.classList.contains('is-open');
        this.transitionDuration = 300;
        this.transitionTimeout = null;
        this.hoverTimeout = null;
        this.matchMedia = window.matchMedia(`(min-width: 1280px)`);
        this.isDesktop = this.matchMedia.matches;

        this.init();
    }

    init() {
        this.matchMedia.addEventListener("change", ({ matches }) => this.isDesktop = matches);

        this.DOM.children.forEach((childNode) => {
            this.children.push(new MenuItem(childNode, this, this.updateOpenItems, this.isModal));
        });
        this.children.forEach((child) => {
            child.siblings = this.children.filter((item) => item !== child);
        });

        this.DOM.toggles.forEach((toggleNode) => {
            toggleNode.addEventListener('click', (event) => {
                event.preventDefault();
                this.toggle(toggleNode);
            });
        });

        if (this.primary) {
            this.DOM.backdrop.addEventListener('click', () => {
                this.clearToggles();
                this.close();
            });
        }
    }

    open() {
        this.isOpen = true;

        if (!this.isModal) this.updateOpenItems(this.menuItem, this.isOpen);

        this.siblings.forEach((sibling) => sibling.close());

        if (this.DOM.el.dataset.menuTab) {
            if (this.isDesktop && this.children) {
                this.children[0].DOM.el.classList.add('is-visible');
                this.children[0].DOM.el.classList.add('is-open');
                this.children[0].DOM.el.parentElement.classList.add('menu__link--section--active');
            }
        }

        clearTimeout(this.transitionTimeout);
        this.DOM.el.classList.add('is-visible');
        this.DOM.el.clientHeight;
        this.DOM.el.classList.add('is-open');
        this.DOM.el.parentElement.classList.add('menu__link--section--active');
    }

    close() {
        this.children.forEach((child) => child.isOpen && child.close());

        this.isOpen = false;
        if (!this.isModal) this.updateOpenItems(this.menuItem, this.isOpen);

        clearTimeout(this.transitionTimeout);
        this.DOM.el.classList.remove('is-open');
        this.DOM.el.parentElement.classList.remove('menu__link--section--active');
        this.DOM.el.classList.remove('is-visible');
    }

    clearToggles() {
        const toggles = document.querySelectorAll(`[data-menu-toggle]`);
        toggles.forEach((item) => item.parentElement.classList.remove('is-active'));
    }

    toggle(toggle) {
        if (this.isDesktop && !toggle.dataset.menuToggle.includes('section')) this.clearToggles();
        
        if (Array.from(toggle.classList).includes('hide-banner')) {
            document.querySelectorAll('.menu__banners').forEach((banner) => {
                banner.classList.add('d-none');
            });
        } else {
            document.querySelectorAll('.menu__banners').forEach((banner) => {
                banner.classList.remove('d-none');
            });     
        }

        if (this.isOpen) {
            this.close();
        } else {
            if (this.isDesktop && !toggle.dataset.menuToggle.includes('section')) toggle.parentElement.classList.add('is-active');
            this.open();
        }
    }
}

const body = document.body;
const openItems = {};
let transitionTimeout = null;
const updateOpenItems = (item, open) => {
    openItems[item] = open;
    if (Object.values(openItems).filter(value => value).length > 0) {
        clearTimeout(transitionTimeout);
        body.classList.add('menu-visible');
        body.clientHeight;
        body.classList.add('menu-open');
    } else {
        body.classList.remove('menu-open');
        clearTimeout(transitionTimeout);
        transitionTimeout = setTimeout(() => {
            body.classList.remove('menu-visible');
        }, 300);
    }
}

function openFirstItemIfDesktop(menuItemInstance) {
    if (menuItemInstance.isDesktop) {
        const firstToggle = menuItemInstance.DOM.el.querySelector('[data-menu-toggle]');

        if (firstToggle) {
            menuItemInstance.toggle(firstToggle);
            const parentDiv = firstToggle.parentElement;
            const nextDiv = parentDiv.querySelector('.menu__item-wrapper.menu__item-wrapper--section');
            
            if (nextDiv) {
                nextDiv.classList.add('is-open');
                nextDiv.classList.add('is-visible');
            }
        }
    }
}

const menuItemNode = document.querySelector('[data-menu-item="primary"]');
if (menuItemNode !== null) {
    new MenuItem(menuItemNode, null, updateOpenItems, false);
}

const menuMoreItemNode = document.querySelector('[data-menu-item="more"]');
if (menuMoreItemNode !== null) {
    const menuMoreItem = new MenuItem(menuMoreItemNode, null, updateOpenItems, true);
    openFirstItemIfDesktop(menuMoreItem);
}
